export const environment = {
  production: false,
  apiUrl: 'https://dev.edubelin.fr',
  env: 'prep',
  hotLicenseKey: 'non-commercial-and-evaluation',
  clientId: '3abde3d8-d4d9-49e6-939a-405a93578398',
  authority: 'https://login.microsoftonline.com/b366bf05-f2fe-4708-be3f-91e4f3ba509a',
  redirectUri: 'https://dev.ogrn.belin-education.com/login',
  // Date à partir de laquelle les restrictions de colonne ( folio et strcutreu ) s'appliquent
  DateDebutRestrictionOuvrage: '2026-09-01',
};
